import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: string[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getHolidaySlice = createSlice({
  name: "getHoliday",
  initialState,
  reducers: {
    getHolidayStart: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getHolidaySuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.holidays;
    },
    getHolidayFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    updateHoliday: (state, action) => {
      state.data = action.payload;
    },
    resetHoliday: () => {
      return { ...initialState };
    },
  },
});

export const {
  getHolidayStart,
  getHolidaySuccess,
  getHolidayFailed,
  resetHoliday,
  updateHoliday,
} = getHolidaySlice.actions;

export default getHolidaySlice.reducer;
